// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__15iXG","colMaxWidth":"Table_colMaxWidth__2KvoN"};